import { h } from 'preact';

const CustomHeight = props => {
  return <div style={{ height: props.height }} />;
};

export default CustomHeight;
